module.exports = shared.AriesComponent;